var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.433,
    height: 44.309,
    viewBox: "0 0 38.433 44.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ear",
    transform: "translate(-33.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1215",
    "data-name": "Grupo 1215",
    transform: "translate(33.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1214",
    "data-name": "Grupo 1214",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_931",
    "data-name": "Caminho 931",
    d: "M48.056,0A14.122,14.122,0,0,0,33.95,14.106V34.663a9.574,9.574,0,0,0,1.6,5.325.649.649,0,0,0,1.08-.72,8.28,8.28,0,0,1-1.385-4.606V14.106a12.808,12.808,0,0,1,25.616,0c0,6.707-2.516,10.075-5.181,13.641A25.324,25.324,0,0,0,50.97,36.3a10.7,10.7,0,0,1-2.8,5.2,6.338,6.338,0,0,1-4.482,1.509,8.449,8.449,0,0,1-5.123-1.7.649.649,0,0,0-.781,1.037,9.737,9.737,0,0,0,5.9,1.961c4.4,0,7.033-2.361,8.533-7.657a23.941,23.941,0,0,1,4.5-8.128c2.674-3.579,5.439-7.28,5.439-14.418A14.122,14.122,0,0,0,48.056,0Z",
    transform: "translate(-33.95)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_932",
    "data-name": "Caminho 932",
    d: "M96.538,67.3a9.407,9.407,0,0,0-15.275,7.357.649.649,0,1,0,1.3,0,8.063,8.063,0,0,1,.9-3.705c1.418-.933,4.564-.745,6.827.94,3.12,2.323,2.439,5.787,1.755,7.645a.649.649,0,1,0,1.218.448,8.693,8.693,0,0,0,.383-5.511,6.977,6.977,0,0,0-2.581-3.624,8.978,8.978,0,0,0-6.35-1.687A8.115,8.115,0,0,1,98.562,72.75a.649.649,0,0,0,1.262-.3A9.469,9.469,0,0,0,96.538,67.3Z",
    transform: "translate(-77.168 -59.595)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_933",
    "data-name": "Caminho 933",
    d: "M94.459,192.236a4.8,4.8,0,0,0,3.992,3.283,5.931,5.931,0,0,0,.767.051,4.628,4.628,0,0,0,3.314-1.357,12.646,12.646,0,0,0,2.185-3.191c.29-.536.565-1.042.848-1.465l.009-.014c.442-.7.919-1.389,1.381-2.058,2.01-2.91,3.909-5.659,4.142-10.137a.649.649,0,0,0-1.3-.068c-.214,4.11-2.011,6.712-3.915,9.468-.467.677-.95,1.376-1.4,2.094-.315.472-.6,1-.905,1.561-1.114,2.054-2.265,4.179-4.957,3.828a3.526,3.526,0,0,1-2.93-2.414,3.664,3.664,0,0,1,.827-3.805,3.568,3.568,0,0,0-2.523-6.09.649.649,0,1,0,0,1.3,2.27,2.27,0,0,1,1.6,3.874A4.953,4.953,0,0,0,94.459,192.236Z",
    transform: "translate(-88.203 -161.376)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_934",
    "data-name": "Caminho 934",
    d: "M362.149,189.494a10.748,10.748,0,0,1,3.169-7.65.649.649,0,0,0-.918-.918,12.117,12.117,0,0,0,0,17.135.649.649,0,0,0,.918-.918A10.747,10.747,0,0,1,362.149,189.494Z",
    transform: "translate(-332.561 -165.095)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_935",
    "data-name": "Caminho 935",
    d: "M451.773,247.4a3.041,3.041,0,0,1,.9-2.164.649.649,0,0,0-.918-.918,4.354,4.354,0,0,0,0,6.164.649.649,0,0,0,.918-.918A3.041,3.041,0,0,1,451.773,247.4Z",
    transform: "translate(-414.428 -222.999)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_936",
    "data-name": "Caminho 936",
    d: "M409,212.642a.649.649,0,0,0-.918,0,8.226,8.226,0,0,0,0,11.646.649.649,0,1,0,.918-.918,6.928,6.928,0,0,1,0-9.81A.649.649,0,0,0,409,212.642Z",
    transform: "translate(-373.493 -194.066)",
    fill: "#d4af37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearActivity);
export default __webpack_public_path__ + "static/media/hearActivity.414c29f3fd3fe25df9f9b071e4f2a6a8.svg";
export { ForwardRef as ReactComponent };